<template>
    <div
        class="d-flex flex-nowrap gap-2"
        @dblclick="editTime"
    >
        <DateComp
            :value="value"
            format="DATETIMEMS3"
        />
        <TooltipComp
            v-if="isStartControlWarning"
            :text="`${$tm('matrix.startcontroloutsidewindow')} 
        ${stationRole?.StartControlMin != null ? `${$tm('matrix.startcontrolmin')} ${stationRole.StartControlMin}  ${$tm('general.sec')}` : ''}
        ${stationRole?.StartControlMax != null ? `${$tm('matrix.startcontrolmax')} ${stationRole.StartControlMax}  ${$tm('general.sec')}` : ''}
        ${$tm('general.usedtime')} ${Math.floor((props.row.AccumulatedTime ?? 0) / 1000)} ${$tm('general.sec')}
         `"
        >
            <IconComp
                family="fa-solid"
                icon="fa-person-running-fast"
                class="fs-5 text-pink-500"
            />
        </TooltipComp>
        <ButtonComp
            class="btn-sm"
            buttonType="Edit"
            @click="editTime"
        />
    </div>
</template>

<script setup lang="ts">
import { DateComp, ButtonComp, AddEditTime, IconComp, TooltipComp } from '@/components';
import { AddEditTimeRequest } from '../Time/AddEditTimeRequest';
import type { ContestantAndRaceContestantTime, RaceContestant } from '@/objects/generated';
import { useDialogBuilder } from '@/composeables/dialog/dialogbuilder';
import { ref } from 'vue';
import { useContestantStore, useEventCommonStoreRef } from '@/stores';
import { hasStartControlWarning } from '@/utilities/timingUtils';
import { computed } from 'vue';

const props = defineProps<{
    value: Date | null;

    row: ContestantAndRaceContestantTime;

    // A callback for when the save button is clicked
    saveCallback?: (request: AddEditTimeRequest) => void;

    raceContestant: RaceContestant | null;
}>();

const contestantStore = useContestantStore();

const editTime = () => {
    const request = ref(
        new AddEditTimeRequest({
            time: props.row.Time,
            raceContestantId: props.row.RaceContestantID,
            bib: props.row.ContestantID == null ? null : (contestantStore.GetContestantById(props.row.ContestantID)?.Bib ?? null),
            stationId: props.row.StationID,
            tuid: props.row.TUID,
        }),
    );

    // TODO: Use globaldialog OpenAddTimeModal (when that has support for selecting the station ID)
    useDialogBuilder()
        .withTitle('contestanttime.edittime')
        .withBodyComponent(AddEditTime, {
            vmodel: request,
        })
        .withCancelButton({
            action: () => {},
        })
        .withSaveButton({
            action: async () => {
                if (props.saveCallback) {
                    props.saveCallback(request.value);
                }
                return true;
            },
        })
        .withOptions({
            Size: 'md',
        })
        .Open();
};

const { StationRoles } = useEventCommonStoreRef();
const stationRole = computed(() => StationRoles.value.find((sr) => sr.ID === props.row.StationRoleID && sr.StartControl));

const isStartControlWarning = computed(
    () =>
        props.raceContestant != null &&
        props.raceContestant.StartingTime != null &&
        stationRole.value != null &&
        hasStartControlWarning(props.raceContestant.StartingTime, stationRole.value, props.row.Time),
);
</script>
